module.exports = __webpack_public_path__ + "img/8bb8669.png";